module.exports = __webpack_public_path__ + "img/codeD.f8e45673.svg";